import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';

const useAddVendorAlias = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, alias }: { id: number; alias: string }) => {
      return (await glynt).vendor.addVendorAlias(id, alias);
    },

    ...callbacks,

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['vendors']
      });
    }
  });
};

export default useAddVendorAlias;
